import { Component } from '@angular/core';

/**
 * Full-screen splash with the Nawam logo + a spinner under it. Designed to
 * be the visual continuation of the static splash defined in `index.html`
 * (same logo, same spinner colors, same layout) so the transition from
 * "before Angular bootstrap" → "Angular booting" is seamless.
 *
 * Usage : `<app-app-splash *ngIf="auth.booting()" />` at the root of
 * `AppComponent`. Once the auth service finishes its silent refresh + /me,
 * the splash unmounts and the router-outlet takes over.
 */
@Component({
  selector: 'app-app-splash',
  standalone: true,
  templateUrl: './app-splash.component.html',
  styleUrl: './app-splash.component.css',
})
export class AppSplashComponent {}
